<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Certificate Text Definitions</h5>
      <form [formGroup]="AddNewDefinitionscertificate" (submit)="SubmitAddNewDefinitionscertificate()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_QUANTITY(templateQUANTITY)" class="btn btn-danger left"> Select Subquantity  <i class="fa fa-lastfm-square"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
          </div>
        </div>

        <div class="row" *ngIf="Data_Seleted_Record.id>0">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Calibration Method</label>
            <input formControlName="CALIBRATIONMETHOD" type="text" style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"   placeholder="Type here...">
            <small *ngIf="!get_Form_CALIBRATIONMETHOD().valid && get_Form_CALIBRATIONMETHOD().touched" class="form-text text-muted MyErrorRedColor">Enter the Calibration Method.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Uncertainty</label>
            <input formControlName="UNCERTAINTY" type="text" style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"   placeholder="Type here...">
            <small *ngIf="!get_Form_UNCERTAINTY().valid && get_Form_UNCERTAINTY().touched" class="form-text text-muted MyErrorRedColor">Enter the Measurement Uncertainty.</small>
          </div>
        </div>

        <div class="row" *ngIf="Data_Seleted_Record.id>0">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Traceability</label>
            <input formControlName="TRACEABILITY" type="text" style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"   placeholder="Type here...">
            <small *ngIf="!get_Form_TRACEABILITY().valid && get_Form_TRACEABILITY().touched" class="form-text text-muted MyErrorRedColor">Enter the Traceability statement.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Decision Rule</label>
            <input formControlName="DecisionRule" type="text" style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"   placeholder="Type here...">
            <small *ngIf="!get_Form_DecisionRule().valid && get_Form_DecisionRule().touched" class="form-text text-muted MyErrorRedColor">Enter the Decision Rule.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Code</label>
            <input formControlName="Code" type="text" style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"   placeholder="Type here...">
            <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched" class="form-text text-muted MyErrorRedColor">Enter the code.</small>
          </div>
        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && Data_Seleted_Record.id>0" type="submit" [disabled]="!AddNewDefinitionscertificate.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing && Data_Seleted_Record.id>0" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/Definitionscertificate" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>



<ng-template #templateQUANTITY>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Subquantity List</h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_QUANTITY.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Title Subquantity </label>
            <input  type="text" class="form-control"  [(ngModel)]="Search_Name_QUANTITY_Table"  placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Measurement Quantity</th>
              <th>Subquantity</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_QUANTITY
            |filter:Search_Name_QUANTITY_Table:'title'
            | paginate
                    : {
                        id: 'DataList_QUANTITY',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_QUANTITY|filter:Search_Name_QUANTITY_Table:'title').length
                      }">
              <td>{{DataList_QUANTITY.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.parentTitle}}</td>
              <td (click)="Set_Selected_QUANTITY_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>

 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingQUANTITY" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingQUANTITY" type="button" (click)="ReadData_QUANTITY()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_QUANTITY.hide()">Close</button>
  </div>
</ng-template>
